export default __webpack_public_path__ + "static/media/IMG_0391.0350e822.jpg";